import { isObject } from 'common/helpers'
import type { Nullable } from 'common/types'

import type { BaseEntity, SelectedTreeObject } from '../types'

export const isPropertyOfSpecificType = <
  ObjectT extends { entityType: DiscriminatorT }, //тип объекта
  PropertyT, //тип свойства
  DiscriminatorT, //тип свойства-дискриминатора
  CheckedType extends PropertyT, //проверяемый тип
>(
  object: ObjectT | undefined,
  property: PropertyT | undefined,
  type: DiscriminatorT,
): property is CheckedType => object?.entityType === type

export const isRecord = (candidate: unknown): candidate is Record<string, unknown> =>
  !!candidate && isObject(candidate)

export function convertToBaseEntity(treeObject: SelectedTreeObject): BaseEntity {
  const { entityId, entityType, entityName } = treeObject
  return { entityId, entityType, entityName }
}

export function getFileName(objectName: string | undefined, fileName: string) {
  const file = objectName ? objectName : fileName
  return /(.+?)(\.[^.]*$|$)/.exec(file)?.[1] ?? ''
}

export function setToStorage<T>(
  key: string,
  convertToLocalStorage: (item: T) => string,
  value: T,
): void {
  try {
    window.localStorage.setItem(key, convertToLocalStorage(value))
  } catch (error) {
    console.error(error)
  }
}

export function getFromStorage<T>(
  key: string,
  convertFromLocalStorage: (item: Nullable<string>) => T,
): Nullable<T> {
  try {
    const item = window.localStorage.getItem(key)
    return item ? convertFromLocalStorage(item) : null
  } catch (error) {
    console.error(error)
    return null
  }
}
